export class S1BufferContent {
    'Plain';
    'GZipped';
    'None'
}